import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { isSeeqPreviewEnabled } from '@/services/systemConfiguration.utilities';
import { getWorkbooksLink } from '@/main/routing.utilities';
import seeqLogo from 'resources/img/Seeq_logo_white@2x.png';
import seeqLogoPreview from 'resources/img/Seeq_preview_logo_white@2x.png';
import { WrapperWithLink } from '@/core/WrapperWithLink.atom';
import { resetWorkbookType, setWorkbookDisplayMode } from '@/workbook/workbook.actions';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

interface HeaderLogoProps {
  ignoreConfigError?: boolean;
  disableLink?: boolean;
}

const seeqPreviewEnabled = (ignoreConfigError: boolean) => {
  try {
    return isSeeqPreviewEnabled();
  } catch (e) {
    if (ignoreConfigError) {
      return false;
    }

    throw e;
  }
};

export const HeaderLogo: React.FunctionComponent<HeaderLogoProps> = ({
  ignoreConfigError = false,
  disableLink = false,
}) => {
  const navigate = useNavigate();

  const gotoHomeScreen = () => {
    resetWorkbookType();
    navigate(getWorkbooksLink());
    setWorkbookDisplayMode(WORKBOOK_DISPLAY.EDIT);
  };

  const isSeeqPreviewEnabled = () => seeqPreviewEnabled(ignoreConfigError);

  return (
    <div
      className={clsx('headerLogo', isSeeqPreviewEnabled() ? 'tw:w-[130px]' : 'tw:w-[80px]')}
      data-testid="headerLogo">
      <WrapperWithLink link={getWorkbooksLink()}>
        <div className={clsx('navbar-nav pl0 pr0', disableLink ? 'cursorDefault' : 'cursorPointer')}>
          <img
            className="mt4 mr15 mb5 ml5"
            src={isSeeqPreviewEnabled() ? seeqLogoPreview : seeqLogo}
            height={28}
            width={isSeeqPreviewEnabled() ? 130 : 80}
            onClick={disableLink ? undefined : gotoHomeScreen}
            data-testid="headerImage"
          />
        </div>
      </WrapperWithLink>
    </div>
  );
};
